import { render, staticRenderFns } from "./RecentTransactions.vue?vue&type=template&id=38874a06&scoped=true&"
import script from "./RecentTransactions.vue?vue&type=script&lang=ts&"
export * from "./RecentTransactions.vue?vue&type=script&lang=ts&"
import style0 from "./RecentTransactions.vue?vue&type=style&index=0&id=38874a06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38874a06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
